import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { PageTitle } from '../PageTitle';
import AssetComparisonReportForm from './asset_comparison_report_form';
import AssetComparisonReportResults from './asset_comparison_report_results';
import { GroupingsService } from '../../services';
import i18next from "i18next";

const AssetComparisonReport = ({ currentGrouping }) => {
    const [availableGroupings, setAvailableGroupings] = useState(null);
    const [query, setQuery] = useState(null);

    useEffect(() => {
        GroupingsService.listAll().then((response) => {
            const leafGroupings = response.groupings
                .filter((grouping) => grouping.deviceGroup?.children?.length == 0)
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((grouping) => ({ value: grouping.id, label: grouping.name, grouping: grouping }));
    
            setAvailableGroupings(leafGroupings);
          }).catch((error) => {
            // TODO this.setState({ errorMessage: i18next.t('messages.could-not-load-groupings') });
            console.error(error);
          });
    }, []);

    return availableGroupings ? (
        <div className="animated fadeIn">
            <div className="row">
                <PageTitle title={ i18next.t('pages.asset-comparison-report.header') } />
            </div>
            <div className="device-detail-report col-sm-12">
                <AssetComparisonReportForm   
                    availableGroupings = {availableGroupings}
                    onSubmit = {(newQuery) => { if (newQuery !== query) { setQuery(newQuery) } }}
                />
            </div>
            { query &&
            <div className = "device-detail-report col-sm-12">
                <AssetComparisonReportResults currentGrouping = {currentGrouping} query = {query} />
            </div>}
        </div>
    ) : (<div className="loader">{ i18next.t('loading') }</div>)
}

export default connect(state => ({ currentGrouping: state.currentGrouping.currentGrouping }))(AssetComparisonReport);